// Module
var code = "<div class=\"vui-input-container\" ng-transclude></div>\n";
// Exports
module.exports = code;